import React, { useState } from "react";
import { Box } from "@mui/material";
import Slider from "../Slider/Slider";
import Products from "../Products/Products";

const HomePage = ({
  products,
  productTypes,
  categories,
  productColors,
  productMetals,
  productGemstones,
  pearlTypes,
  pearlSizes,
  ringSizes,
  productLengths,
  productEras,
  discounts,
  setSelectedProduct,
  onAddToCart,
  cart
}) => {
  const [showSlider, setShowSlider] = useState(true);
  const [sliderOff, setSliderOff] = useState(false);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        overflow: "hidden",
        "& > *:first-of-type": {
          px: { xs: 0, sm: 2, md: 3 } // Adjust padding for different screen sizes
        }
      }}
    >
      {/* Hero Section with Slider */}
      {showSlider && !sliderOff && (
        <Box
          sx={{
            width: "100%",
            height: {
              xs: "40vh",
              sm: "60vh",
              md: "85vh"
            },
            mb: 4
          }}
        >
          <Slider setSliderVisible={setShowSlider} setSliderOff={setSliderOff} />
        </Box>
      )}

      {/* Products Section */}
      <Box sx={{ width: "100%", px: { xs: 1, sm: 2, md: 3 } }}>
        <Products
          products={products}
          productTypes={productTypes}
          categories={categories}
          productColors={productColors}
          productMetals={productMetals}
          productGemstones={productGemstones}
          pearlTypes={pearlTypes}
          pearlSizes={pearlSizes}
          ringSizes={ringSizes}
          productLengths={productLengths}
          productEras={productEras}
          discounts={discounts}
          setSelectedProduct={setSelectedProduct}
          onAddToCart={onAddToCart}
          cart={cart}
        />
      </Box>
    </Box>
  );
};

export default HomePage;
